var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"category-thumbnail-container",attrs:{"to":_vm.contentRoute}},[_c('div',{staticClass:"category-thumbnail-title"},[_c('h2',[_vm._v(_vm._s(_vm.title))])]),(_vm.imageUrl)?_c('div',{staticClass:"category-thumbnail-image",style:(_vm.backgroundImage)}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }